import { MeteringSuccessMessage } from '@labrav/common'

import type { CloudMarketplace } from '../../productsListing/types'
import type { ContractsListingMeteringResponse } from '../types'

export const getSuccessMsgForMetering = (
  cloud: CloudMarketplace,
  response: ContractsListingMeteringResponse | undefined
) => {
  switch (cloud) {
    case 'AWS': {
      return MeteringSuccessMessage
    }
    case 'AZURE': {
      return response?.data?.detail || MeteringSuccessMessage
    }
    case 'GCP': {
      return MeteringSuccessMessage
    }
    case 'REDHAT': {
      return ''
    }
  }
}
